import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { ToastContainerProps } from 'react-toastify';
import { Slide, ToastContainer } from 'react-toastify';
type ToastProviderProps = Omit<ToastContainerProps, 'transition'>;
export const ToastProvider = t0 => {
  const $ = _c(13);
  let className;
  let restProps;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      position: t1,
      draggable: t2,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = restProps;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    restProps = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const position = t1 === undefined ? "bottom-center" : t1;
  const draggable = t2 === undefined ? true : t2;
  let t3;
  if ($[5] !== className) {
    t3 = cn("p-0", "max-[1279px]:!right-auto max-[1279px]:!left-1/2 max-[1279px]:!w-[calc(100%-32px)] max-[1279px]:!-translate-x-1/2", className);
    $[5] = className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("!min-h-0 cursor-grab !bg-[rgba(0,0,0,0.7)] backdrop-blur-sm", "whitespace-pre-line !rounded-pill !px-20 !py-12 font-400 !text-Gray-white typo-body4", "!mx-auto !w-fit !max-w-full self-center overflow-hidden break-words");
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== draggable || $[9] !== position || $[10] !== restProps || $[11] !== t3) {
    t5 = <ToastContainer aria-label={"\uC54C\uB9BC"} draggable={draggable} stacked={true} className={t3} closeButton={false} draggableDirection="y" draggablePercent={20} position={position} theme="colored" toastClassName={t4} transition={Slide} {...restProps} />;
    $[8] = draggable;
    $[9] = position;
    $[10] = restProps;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};